module.exports = __webpack_public_path__ + "assets/security-4-1fdb10a69aa8ba6efabdf0ac92830238.svg";